import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
import api from '@/helpers/fetch'

import { library } from '@fortawesome/fontawesome-svg-core'

import {
	faCirclePlay,
	faCirclePause,
} from '@fortawesome/free-regular-svg-icons'

library.add(faCirclePlay, faCirclePause)

@Component({
	components: {
		Loader,
	},
})
export default class Podcasts extends Vue {
	@Prop({ required: true }) tags!: [number, string]
	@Prop({ required: true }) title!: string
	@Prop({ required: true }) update!: number

	podcasts = [] as Array<any>
	loading = true

	@Watch('update')
	updateCount() {
		if (this.update > 0) {
			this.loadPodcasts()
		}
	}

	async loadPodcasts() {
		this.loading = true
		const query = [] as Array<any>

		if (this.tags.length > 0) {
			query.push('tags=' + this.tags.join(','))
		}
		if (this.title) {
			query.push('title=' + this.title)
		}

		const res = await api.get(
			'/api/blogging/content-podcasts?' + query.join('&'),
		)
		this.podcasts.length = 0
		this.podcasts.push(
			...res.data.map((podcast) => {
				let [full, hour, min, sec] =
					/(\d{2}):(\d{2}):(\d{2})/.exec(podcast.duration!) || []
				let duration = ''
				duration += parseInt(hour) <= 0 ? '' : hour + 'h '
				duration += parseInt(min) <= 0 ? '' : min + 'm '
				duration += parseInt(sec) <= 0 ? '' : sec + 's'

				podcast.duration = duration

				return podcast
			}),
		)
		this.loading = false
	}

	formatDate(dateString) {
		const d = new Date(dateString)
		return new Intl.DateTimeFormat('pt-BR', {
			day: 'numeric',
			month: 'short',
			year: 'numeric',
		}).format(d)
	}
}
